import React from "react";
import Link from "@material-ui/core/Link";
import LinkAdapter from "./LinkAdapter";
import { isAbsoluteUrl } from "./utils";
const StyledLink = ({ href, children, onClick }) => {
    return (React.createElement(Link, Object.assign({}, (href && isAbsoluteUrl(href) ? undefined : { component: LinkAdapter }), { href: href, onClick: onClick }), children));
};
export default StyledLink;
